import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { StaticImage } from 'gatsby-plugin-image';
import stats from '~assets/stats.json';

const SectionBanner = styled.div`
  clear: both;
  color: #9B1417;
  margin: 6rem 0 2rem;
  text-align: center;
  font-size: 5em;
  opacity: 0.1;
  transform: scale(2);
  transition: all 0.5s ease-out;
  &.min {
    font-size: 2.5em;
  }
  &.inView {
    transform: scale(1);
    opacity: 1;
  }
  @media (min-width: 800px) {
    font-size: 7em;
  }
`;
const StatsBox = styled.div`
  padding: 15px;
  max-width: 300px;
  text-align: center;
  margin: 15px auto;
  @media (min-width: 800px) {
    margin: 0;
    position: relative;
    float: left;
  }
  .age {
    margin-bottom: 5px;
  }
  .teamStats {
    line-height: 1.5;
  }
  .awards {
    margin: 5px auto;
    display: flex;
    gap: 10px;
    justify-content: center;
    .icon {
      padding: 10px;
      display: flex;
      text-align: center;
      flex-direction: column;
    }
  }
  .ortizStats {
    table {
      margin: 5px auto;

      th, td {
        padding: 3px 8px;
        text-align: center;
        background-color: #fff;
      }
      th {
        font-size: 12px;
        background-color: #f6f6f6;
      }
      &.slash td {
        font-size: 1.5rem;
      }
    }
  }
`;

const YearStats = ({ year, inView }) => {
  // console.log(stats[year]);
  if (!stats[year]) return null;
  const statsData = stats[year];

  let yearStyle = `year millerbanner-n4 ${inView}`;
  // Minnesota Years (1997-2002) gets special treatment
  if (year === 'Minnesota Twins years: 1997-2002') {
    yearStyle += ' min';
  }
  let leagueLeader = null;
  if (statsData['Led the league in']) {
    leagueLeader = (
      <div className="bentonsanscond-n6">Led the league in: {statsData['Led the league in']}</div>
    );
  }

  const labelAS = (
    <div className="icon">
      <StaticImage src="../../assets/images/as.png" alt="Selected for All-Star game" />
      <span>All-Star</span>
    </div>
  );
  const labelSS = (
    <div className="icon">
      <StaticImage src="../../assets/images/ss.png" alt="Won Siliver Sliugger award" />
      <span>Silver Slugger</span>
    </div>
  );
  const labelWS = (
    <div className="icon">
      <StaticImage src="../../assets/images/ws.png" alt="Won World Series" />
      <span>World Series</span>
    </div>
  );

  return (
    <section>
      <SectionBanner className={yearStyle}>{year}</SectionBanner>
      <StatsBox>
        <div className="age bentonsanscond-n6">Age: {statsData.Age}</div>
        <div className="teamStats bentonsanscond-n4">
          Manager: {statsData.Manager}
          <br />
          Team record: {statsData['Team record']}
          <br />
          {statsData.Finish}
        </div>
        <div className="awards bentonsanscond-n4">
          {statsData.AS ? labelAS : null}
          {statsData.SS ? labelSS : null}
          {statsData.WS ? labelWS : null}
        </div>
        <div className="ortizStats bentonsanscond-n4">
          {leagueLeader}
          <table>
            <thead>
              <tr>
                <th>G</th>
                <th>AB</th>
                <th>R</th>
                <th>H</th>
                <th>HR</th>
                <th>RBI</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{statsData.G}</td>
                <td>{statsData.AB}</td>
                <td>{statsData.R}</td>
                <td>{statsData.H}</td>
                <td>{statsData.HR}</td>
                <td>{statsData.RBI}</td>
              </tr>
            </tbody>
          </table>
          <table className="slash">
            <thead>
              <tr>
                <th>BA</th>
                <th>OBP</th>
                <th>SLG</th>
                <th>OPS</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{statsData.BA}</td>
                <td>{statsData.OBP}</td>
                <td>{statsData.SLG}</td>
                <td>{statsData.OPS}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </StatsBox>
    </section>
  );
};

export default YearStats;

YearStats.propTypes = {
  year: PropTypes.string.isRequired,
};
